import { z } from 'zod'

export const placeOrderResponseSchema = z.object({
  orderId: z.string(),
  executionStatus: z.string(),
  lotsRequested: z.number().int(),
  lotsExecuted: z.number().int(),
  totalCost: z.number(),
  // per-share executed average price (normalized, matching the persisted column), or null when the
  // broker reported none. lets a synchronous fill be booked at the executed price, not the limit.
  executedPrice: z.number().nullable(),
  message: z.string().optional(),
})

export type PlaceOrderResponseDto = z.infer<typeof placeOrderResponseSchema>
